import { render, staticRenderFns } from "./IconFaceMeh.vue?vue&type=template&id=e5f9440e&"
import script from "./IconFaceMeh.vue?vue&type=script&lang=js&"
export * from "./IconFaceMeh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports